import React from 'react';
import { Table, Button } from 'react-bootstrap';

const StoredLevelsTable = ({ selectedLevels, setShowDeleteLevelsModal, styles }) => {
  return (
    <div style={styles.dataBox} className="shadow p-4">
      <h5>Stored Levels</h5>
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>Index</th>
            <th>Level (CE/PE)</th>
            <th>Lots</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(selectedLevels).map((index) => {
            const { ceLevels, peLevels } = selectedLevels[index];
            const pairedLevels = [];
            ceLevels.forEach((ce) => {
              const pe = peLevels.find((p) => p.level === -ce.level);
              if (pe) {
                pairedLevels.push({
                  ceLevel: ce.level,
                  peLevel: pe.level,
                  lots: ce.numberOfLots || pe.numberOfLots || 1
                });
              } else {
                pairedLevels.push({
                  ceLevel: ce.level,
                  peLevel: null,
                  lots: ce.numberOfLots || 1
                });
              }
            });
            peLevels.forEach((pe) => {
              if (!ceLevels.find((c) => c.level === -pe.level)) {
                pairedLevels.push({
                  ceLevel: null,
                  peLevel: pe.level,
                  lots: pe.numberOfLots || 1
                });
              }
            });
            const levelDetails = pairedLevels.length
              ? pairedLevels.map(({ ceLevel, peLevel, lots }) => {
                  const ceText = ceLevel !== null ? (ceLevel >= 0 ? `+${ceLevel}` : ceLevel) : '--';
                  const peText = peLevel !== null ? (peLevel >= 0 ? `+${peLevel}` : peLevel) : '--';
                  return {
                    levelText: `${ceText}/${peText}`,
                    lots
                  };
                }).sort((a, b) => {
                  const aLevel = parseInt(a.levelText.split('/')[0]) || 0;
                  const bLevel = parseInt(b.levelText.split('/')[0]) || 0;
                  return aLevel - bLevel;
                })
              : [{ levelText: 'None', lots: 'None' }];

            return levelDetails.map((detail, i) => (
              <tr key={`${index}-${i}`}>
                {i === 0 && <td rowSpan={levelDetails.length}>{index}</td>}
                <td>{detail.levelText}</td>
                <td>{detail.lots}</td>
                {i === 0 && (
                  <td rowSpan={levelDetails.length}>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => setShowDeleteLevelsModal(index)}
                      disabled={ceLevels.length === 0 && peLevels.length === 0}
                    >
                      Manage Levels
                    </Button>
                  </td>
                )}
              </tr>
            ));
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default StoredLevelsTable;